import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Logger } from 'src/services/core/logger/logger.service';
import { RestaurantService } from 'src/services/data/restaurant/restaurant.service';
import { untilDestroyed } from 'src/services/core/until-destroyed/until-destroyed';
import { Response } from 'src/services/classes/models/response';
import { LoaderService } from 'src/services/classes/loader/loader.service';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';
import { OrdersService } from 'src/services/data/orders/orders.service';
import { CartService } from 'src/services/data/cart/cart.service';

const log = new Logger('MaiAwaiting Payment');

@Component({
  selector: 'app-awaiting-payment',
  templateUrl: './awaiting-payment.component.html',
  styleUrls: ['./awaiting-payment.component.scss'],
})
export class AwaitingPaymentComponent implements OnInit {
  paymentMode!: string;
  paymentPayload: any = null;
  restaurantId = null;
  constructor(
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private restaurantService: RestaurantService,
    private loaderService: LoaderService,
    private notifyService: NotificationsService,
    private ordersService: OrdersService,
    private cartService: CartService
  ) {}

  ngOnInit(): void {
    this.getPaymentMode();
    const restaurantInfo =
      this.restaurantService.fetchRestaurantInformation() || null;
    this.restaurantId = restaurantInfo.restaurantId;
  }

  getPaymentMode() {
    this.paymentPayload = JSON.parse(
      localStorage.getItem('payment-notification-payload') || 'null'
    );
    this.route.queryParamMap.subscribe((params: Params) => {
      const paymentModeObject = { ...params };
      for (let value in paymentModeObject) {
        if (this.paymentPayload || paymentModeObject[value]['mode']) {
          this.paymentMode = paymentModeObject[value]['mode'] || '';
          log.debug('payment mode: ', this.paymentMode);
          const tableNumber = localStorage.getItem('table-number');
          if (tableNumber !== null) {
            this.notifyWaiter(Number(tableNumber), this.paymentMode);
          }
        } else {
          this.location.back();
        }
      }
    });
  }

  handleBackNavigation() {
    this.location.back();
  }

  goForOnlinePayment() {
    this.router.navigateByUrl('/collect-email');
  }

  notifyWaiter(tableId: number, mode: string) {
    const payload =
      this.paymentPayload || {
        notificationType: 'split-payment',
        paymentType: 'full',
        mode,
      };
    const notify$ = this.restaurantService.notifyWaiterWithPayload(
      tableId,
      payload
    );
    notify$.pipe(untilDestroyed(this)).subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() !== 'error') {
          res.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Waiter has been notified',
                'success',
                1
              );
        } else {
          this.notifyService.publishMessages(res.message, 'danger', 1);
          this.loaderService.hide();
        }
      },
      error: (err: any) => this.loaderService.hide(),
      complete: () => {
        setTimeout(() => {
          const orderData = JSON.parse(localStorage.getItem('orderData')) || null;
          log.debug('Parsed orderData:', orderData);
          
          // Access the first order from the orders array
          const orderId = orderData?.orders?.[0]?.id;
          log.debug('orderId:', orderId);
          
          if (orderId) {
            this.confirmPayment(orderId);
          } else {
            log.debug('Order ID not found in localStorage');
            this.notifyService.publishMessages('Order details not found', 'danger', 1);
          }
        }, 3000);
      },
    });
  }

  confirmPayment(recentOrderId: number) {
    const confirmPayment$ = this.ordersService.confirmPayment(recentOrderId);
    confirmPayment$.pipe(untilDestroyed(this)).subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() !== 'error') {
          res.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Payment has been confirmed',
                'success',
                1
              );
          this.handleClearTableAndOrderDetails();
        } else {
          // this.notifyService.publishMessages(res.message, 'danger', 1);
          log.debug('Hit else block!');
        }
      },
      error: (err) => {
        setTimeout(() => {
          this.confirmPayment(recentOrderId);
        }, 30 * 1000);
      },
    });
  }

  handleClearTableAndOrderDetails() {
    this.cartService.clearCart();
    localStorage.removeItem('cart');
    localStorage.removeItem('cartTotal');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('success-page-cartTotal');
    localStorage.removeItem('success-page-cart');
    localStorage.removeItem('forSuccessPage');
    localStorage.removeItem('table-number');
    localStorage.removeItem('restaurant');
    localStorage.removeItem('orderData');
    localStorage.removeItem('allOrders');
    localStorage.removeItem('hasChosenOption');
    localStorage.removeItem('order-placed');
    localStorage.removeItem('order-type');
    localStorage.removeItem('payment-notification-payload');
  
    this.router.navigateByUrl('/').then(() => {
      dispatchEvent(
        new CustomEvent('reload-page', {
          bubbles: false,
          cancelable: false,
        })
      );
      log.debug('routed and broadcasted event!');
    });
  }

  // TODO: clearing items here will lead to a bug if the user decides to make online payment instead!
  ngOnDestroy(): void {
    // this.cartService.clearCart();
    // localStorage.removeItem('success-page-cartTotal');
    // localStorage.removeItem('success-page-cart');
    // localStorage.removeItem('restaurant');
    // localStorage.removeItem('table-number');
    // localStorage.removeItem('orderData');
    // localStorage.removeItem('allOrders');
  }
}
